export default __webpack_public_path__ + "static/media/image11.eb20e48b.jpg";